<template>
  <div>
    <h1 class="page-header">{{ $t('termsemester.termsemester') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button
            outline
            color="info"
            @click.prevent="() => (show_form = true)"
            >{{ $t('add_new') }}</ts-button
          >
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('invoice.filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
        <!-- drawer -->
        <a-drawer
          :title="$t('filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="() => (visible = false)"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="ts-text-xs">{{
                  $t('termSemester.branch')
                }}</label>
                <a-select
                  style="width: 257px"
                  v-model="branch_id"
                  :options="branchs"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                >
                </a-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="ts-text-xs">{{
                  $t('termSemester.status')
                }}</label>
                <a-select class="ts-w-full" v-model="status" mode="multiple">
                  <a-select-option :value="1">
                    {{ $t('termsemester.current') }}
                  </a-select-option>
                  <a-select-option :value="2">
                    {{ $t('termsemester.history') }}
                  </a-select-option>
                  <a-select-option :value="3">
                    {{ $t('termsemester.next') }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-loading-banner :loading="exporting">
          <Table
            :columns="columns"
            :data="groupResources"
            :span-method="handleSpan"
            :loading="loading"
            max-height="700"
            stripe
            highlight-row
            size="small"
            row-key="index"
          >
            <template slot-scope="{ row }" slot="branch_name_en">
              {{ row.branch ? row.branch.branch_name_en : '' }}
            </template>
            <template slot-scope="{ row }" slot="term_name">
              <span v-if="row.ac_term_id != model.ac_term_id">{{
                row.term_name
              }}</span>
              <input
                v-model="model.term_name"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('term_name') }"
                v-if="row.ac_term_id == model.ac_term_id"
              />
            </template>
            <template slot-scope="{ row }" slot="term_start">
              <span v-if="row.ac_term_id != model.ac_term_id">{{
                row.term_start
              }}</span>
              <ts-date-picker-input
                v-if="row.ac_term_id == model.ac_term_id"
                v-model="model.term_start"
              ></ts-date-picker-input>
            </template>
            <template slot-scope="{ row }" slot="term_stop">
              <span v-if="row.ac_term_id != model.ac_term_id">{{
                row.term_stop
              }}</span>
              <ts-date-picker-input
                v-if="row.ac_term_id == model.ac_term_id"
                v-model="model.term_stop"
              ></ts-date-picker-input>
            </template>
            <template slot-scope="{ row }" slot="ac_year">
              {{ row.ac_year ? row.ac_year.ac_year : '' }}
            </template>
            <template slot-scope="{ row }" slot="ac_status_description">
              {{ row.ac_status ? row.ac_status.ac_status_description : '' }}
            </template>
            <template slot-scope="{ row }" slot="ac_status_id">
              <button
                class="btn btn-xs btn-green"
                v-tooltip="'Click to stop term'"
                v-if="row.ac_status_id == 1"
                @click.prevent="switchTerm(0, row)"
              >
                <i
                  class="fa fa-cog spin spiner mr-1"
                  v-if="!row._switching"
                ></i>
                <i class="fas fa-circle-notch spin" v-if="row._switching"></i>
                <span v-if="!row._switching">{{
                  $t('termsemester.starting')
                }}</span>
              </button>
              <button
                class="btn btn-xs btn-default"
                v-tooltip="'Click to start term'"
                v-if="row.ac_status_id == 3"
                @click.prevent="switchTerm(1, row)"
              >
                <i class="fa fa-play mr-1" v-if="!row._switching"></i>
                <i class="fas fa-circle-notch spin" v-if="row._switching"></i>
                <span v-if="!row._switching">{{
                  $t('termsemester.start')
                }}</span>
              </button>
              <button
                class="btn btn-xs btn-danger"
                v-tooltip="'Term has been stoped'"
                v-if="row.ac_status_id == 2"
              >
                <i class="fa fa-cog mr-1"></i>{{ $t('termsemester.stoped') }}
              </button>
            </template>
            <template slot-scope="{ row }" slot="action">
              <ts-button
                v-if="row.ac_term_id == model.ac_term_id"
                class="btn-xs btn-primary mr-2"
                @click="update(row)"
              >
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fa fa-save" v-else></i>
              </ts-button>
              <ts-button
                @click="cancel"
                v-if="row.ac_term_id == model.ac_term_id"
                class="btn-xs btn-default"
              >
                <i class="fa fa-times"></i>
              </ts-button>

              <a
                v-if="
                  row.ac_status_id != 2 && row.ac_term_id != model.ac_term_id
                "
                href="#"
                class="text-primary mr-2"
                v-tooltip="'Edit'"
                @click.prevent="edit(row)"
              >
                <i class="fa fa-edit"></i>
              </a>
              <a
                href="#"
                class="text-info ts-mr-2"
                @click.prevent="copyTerm(row)"
                v-tooltip="$t('copy')"
              >
                <i class="fas fa-copy"></i>
              </a>
              <a
                v-if="row.ac_term_id != model.ac_term_id"
                href="#"
                class="text-danger"
                v-tooltip="'Delete'"
                @click.prevent="destroy(row)"
              >
                <i class="fa fa-trash" v-if="!row._deleting"></i>
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
              </a>
            </template>
          </Table>
        </ts-loading-banner>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form action -->
      <a-modal
        v-if="show_form"
        v-model="show_form"
        :title="$t('termsemester.pageTitle')"
        :zIndex="1020"
        :footer="null"
        :maskClosable="false"
        width="60%"
      >
        <form-create-component
          @close="() => (show_form = false)"
          @fetch="fetchData"
        >
        </form-create-component>
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import { Errors } from 'form-backend-validation'
import FormCreateComponent from './form-create'
import iTable from '@/store/i-table-helper'

export default {
  name: 'term-semester',
  components: {
    FormCreateComponent
  },
  data () {
    return {
      visible: false,
      branchs: [],
      switching: false,
      loading: false,
      errors: new Errors(),
      show_form: false,
      exporting: false,
      model: {
        ac_term_id: '',
        ac_year_id: '',
        acps_id: '',
        term_name: '',
        term_start: '',
        term_stop: '',
        term_order: ''
      }
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.setEditData()
    this.getBranch()
  },
  computed: {
    ...mapState('termSemester', ['resources', 'pagination', 'edit_data']),
    groupResources () {
      return iTable.rowGroup(this.resources, 'acps.acps_name_foreign')
    },
    search: {
      get () {
        return this.$store.state.termSemester.search
      },
      set (newValue) {
        this.$store.commit('termSemester/SET_SEARCH', newValue)
        this.$store.commit('termSemester/RESET_CURRENT_PAGE')
      }
    },
    status: {
      get () {
        return this.$store.state.termSemester.ac_status_id
      },
      set (newValue) {
        this.$store.commit('termSemester/SET_STATUS_ID', newValue)
      }
    },
    branch_id: {
      get () {
        return this.$store.state.termSemester.branch_id
      },
      set (newValue) {
        this.$store.commit('termSemester/SET_BRANCH_ID', newValue)
      }
    },
    columns () {
      return [
        {
          key: 'column_name',
          tree: true,
          maxWidth: 15,
          className: 'text-primary bold'
        },
        {
          title: this.$t('termsemester.branch'),
          slot: 'branch_name_en',
          minWidth: 100
        },
        {
          title: this.$t('termsemester.academicTerm'),
          slot: 'term_name',
          minWidth: 130
        },
        {
          title: this.$t('termsemester.startDate'),
          slot: 'term_start',
          minWidth: 100
        },
        {
          title: this.$t('termsemester.stopDate'),
          slot: 'term_stop',
          minWidth: 100
        },
        {
          title: this.$t('termsemester.order'),
          key: 'term_order',
          minWidth: 100,
          align: 'center'
        },
        {
          title: this.$t('termsemester.academicYear'),
          slot: 'ac_year',
          minWidth: 100
        },
        {
          title: this.$t('termsemester.status'),
          minWidth: 80,
          slot: 'ac_status_description'
        },
        {
          title: this.$t('termsemester.process'),
          minWidth: 100,
          slot: 'ac_status_id'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 120
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'termSemester/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    async switchTerm (action, record) {
      if (action == 1) {
        if (await this.$confirmModal.danger('Are you sure to start term')) {
          record._switching = true
          this.$store
            .dispatch('termSemester/switchTerm', {
              action: action,
              ac_term_id: record.ac_term_id
            })
            .then(response => {
              record._switching = false
              this.fetchData()
              this.$toasted.success(response.message)
            })
            .catch(error => {
              record._switching = false
              this.$toasted.error(error.message)
            })
        }
      }

      if (action == 0) {
        if (await this.$confirmModal.danger('Are you sure to end term')) {
          record._switching = true
          this.$store
            .dispatch('termSemester/switchTerm', {
              action: action,
              ac_term_id: record.ac_term_id
            })
            .then(response => {
              record._switching = false
              this.fetchData()
              this.$toasted.success(response.message)
            })
            .catch(error => {
              record._switching = false
              this.$toasted.error(error.message)
            })
        }
      }
    },
    edit (record) {
      this.errors = new Errors()
      this.$store.commit('termSemester/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'term-semester-edit',
        params: { id: record.ac_term_id }
      })
    },
    async copyTerm (record) {
      this.$store.commit('termSemester/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'term-semester-copy-term',
        params: { id: record.ac_term_id }
      })
    },
    update (record) {
      record._deleting = true
      this.$store
        .dispatch('termSemester/update', this.model)
        .then(response => {
          record._deleting = false
          this.$toasted.success(response.message)
          this.fetchData()
          this.cancel()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          record._deleting = false
        })
    },
    cancel (record) {
      this.model = {
        ac_term_id: '',
        ac_year_id: '',
        acps_id: '',
        term_name: '',
        term_start: '',
        term_stop: '',
        term_order: ''
      }
      this.$router.push({ name: 'term-semester' })
      this.$store.commit('termSemester/SET_EDIT_DATA', {})
    },
    setEditData () {
      if (!_.isEmpty(this.edit_data)) {
        this.model = _.clone(this.edit_data)
      }
    },
    async destroy (record) {
      if (await this.$confirmModal.danger('Are you sure to delete')) {
        record._deleting = true
        this.$store
          .dispatch('termSemester/destroy', record.ac_term_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    handleSpan ({ row, column, rowIndex, columnIndex }) {
      return iTable.handleSpan(row, columnIndex, this.columns)
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    edit_data: {
      handler () {
        this.setEditData()
      },
      deep: true
    },
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500),
    status: debounce(function (value) {
      this.fetchData({ branch_id: this.branch_id })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('termSemester/RESET_STATE')
      this.$store.commit('termSemester/edit_data', {})
      this.$store.commit('termSemester/GET_SUB_PROGRAM', [])
      this.$store.commit('termSemester/GET_AC_YEAR', [])
    }
    next()
  }
}
</script>

<style lang="css">
.bold {
  font-weight: bold;
}
</style>
